import Client from "./client.js";
import Request from "./request.js";

const client = new Client();

export default { client, Client, Request };
